import { Koi } from '@ksyos/koi';

export const afwijkingenV1 = Koi.object().keys({
    afwijking_details: Koi.object().keys({
        av_geleiding: Koi.object().keys({
            anders: Koi.string().max(1000).allow(null),
            eerste_graads_av_blok: Koi.boolean(),
            normale_geleiding: Koi.boolean(),
            totaal_av_blok: Koi.boolean(),
            tweede_graads_av_blok_type_mobitz: Koi.boolean(),
            tweede_graads_av_blok_typewenckebach: Koi.boolean(),
        }),
        elektrische_hartas: Koi.object().keys({
            anders: Koi.string().max(1000).allow(null),
            extreme_as: Koi.boolean(),
            horizontale_hartas: Koi.boolean(),
            intermediair: Koi.boolean(),
            linker_asdeviatie: Koi.boolean(),
            rechter_asdeviatie: Koi.boolean(),
            verticale_hartas: Koi.boolean(),
        }),
        overig: Koi.object().keys({
            anders: Koi.string().max(1000).allow(null),
            linker_boezem_overbelasting: Koi.boolean(),
            prominente_u_golf: Koi.boolean(),
            rechter_boezem_overbelasting: Koi.boolean(),
        }),
        qrs_geleiding: Koi.object().keys({
            anders: Koi.string().max(1000).allow(null),
            aspecifieke_iv_geleidingsvertraging: Koi.boolean(),
            compleet_lbtb: Koi.boolean(),
            compleet_rbtb: Koi.boolean(),
            fasciculus_anticus_blok: Koi.boolean(),
            fasciculus_posticus_blok: Koi.boolean(),
            incompleet_lbtb: Koi.boolean(),
            incompleet_rbtb: Koi.boolean(),
            qrs_normale_breedte: Koi.boolean(),
        }),
        qrs_vorm: Koi.object().keys({
            achterwand_infarct: Koi.boolean(),
            anders: Koi.string().max(1000).allow(null),
            hoog_lateraal_infarct: Koi.boolean(),
            inferolateraal_infarct: Koi.boolean(),
            laag_voltage_in_standaard_afleidingen: Koi.boolean(),
            normaal_voltage: Koi.boolean(),
            onderwand_infarct: Koi.boolean(),
            pre_exitatie: Koi.boolean(),
            tekenen_van_lvh: Koi.boolean(),
            tekenen_van_rvh: Koi.boolean(),
            trage_r_top_progressie_over_voorwand: Koi.boolean(),
            voorwand_infarct: Koi.boolean(),
        }),
        ritme: Koi.object().keys({
            anders: Koi.string().max(1000).allow(null),
            atriaal_pacemakerritme: Koi.boolean(),
            atriale_tachycardie: Koi.boolean(),
            atriumfibrilleren: Koi.boolean(),
            atriumflutter: Koi.boolean(),
            av_nodaal_ritme: Koi.boolean(),
            avnrt: Koi.boolean(),
            ddd_pacemakerritme: Koi.boolean(),
            ectopisch_boezemritme: Koi.boolean(),
            fusie_complex: Koi.boolean(),
            geblokkeerde_pac_bij_av_geleiding: Koi.boolean(),
            niet_te_bepalen_ritme: Koi.boolean(),
            prematuur_atriaal_complex: Koi.boolean(),
            prematuur_ventriculair_complex: Koi.boolean(),
            sa_block: Koi.boolean(),
            sinus_arrest: Koi.boolean(),
            sinusaritmie: Koi.boolean(),
            sinusritme: Koi.boolean(),
            sinustachycardie: Koi.boolean(),
            supraventriculair_ritmestoornis: Koi.boolean(),
            torsades_des_pointes: Koi.boolean(),
            ventriculair_escaperitme: Koi.boolean(),
            ventriculair_pacemakerritme: Koi.boolean(),
            ventriculaire_tachycardie_non_sustained: Koi.boolean(),
            ventriculaire_tachycardie_sustained: Koi.boolean(),
        }),
        st_segment: Koi.object().keys({
            aspecifieke_repolarisatiestoornissen: Koi.boolean(),
            geen_ischemie: Koi.boolean(),
            secundaire_repolarisatie_stoornissen: Koi.boolean(),
            wel_ischemie: Koi.string().max(1000).allow(null),
        }),
    }),
    afwijking_in: Koi.object().keys({
        av_geleiding: Koi.boolean(),
        elektrische_hartas: Koi.boolean(),
        overig: Koi.boolean(),
        qrs_geleiding: Koi.boolean(),
        qrs_vorm: Koi.boolean(),
        ritme: Koi.boolean(),
        st_segment: Koi.boolean(),
    }),
});

export const afwijkingenV1Draft = afwijkingenV1.concat(
    Koi.object().keys({
        afwijking_details: Koi.object().keys({
            av_geleiding: Koi.object().keys({
                anders: Koi.any().allow(''),
            }),
            elektrische_hartas: Koi.object().keys({
                anders: Koi.any().allow(''),
            }),
            overig: Koi.object().keys({
                anders: Koi.any().allow(''),
            }),
            qrs_geleiding: Koi.object().keys({
                anders: Koi.any().allow(''),
            }),
            qrs_vorm: Koi.object().keys({
                anders: Koi.any().allow(''),
            }),
            ritme: Koi.object().keys({
                anders: Koi.any().allow(''),
            }),
            st_segment: Koi.object().keys({
                wel_ischemie: Koi.any().allow(''),
            }),
        }),
    })
);
